var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_49292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0556 78.3648H66.5342C69.3248 74.3931 74.5139 73.2737 76.1359 72.7425C77.7579 72.2113 82.9315 71.5915 86.1761 72.7425C87.7319 73.2944 91.7146 74.8583 94.4623 77.6122C97.4446 80.6012 98.8909 82.9688 99.9429 86.7317C100.995 90.4947 100.487 95.6742 99.9429 97.4007C99.3985 99.1272 98.2157 102.078 95.4707 105.059C92.6639 108.108 89.4207 109.531 86.1761 110.416C82.9315 111.301 79.2924 111.08 76.1359 110.416C72.9794 109.752 68.6319 107.928 66.5342 103.289H40.4912C37.8438 107.391 31.6786 109.796 29.2234 110.416C26.7682 111.036 21.5947 111.098 18.6571 110.416C15.7195 109.734 7.7394 103.868 5.72326 96.7809C4.52725 92.577 5.02178 88.3254 5.72326 85.5807C6.42474 82.836 11.3779 75.268 18.6571 72.7425L32.0732 27.2332L27.9081 26.1708C20.7945 24.2833 18.9202 16.697 18.6571 15.9445C18.394 15.1919 17.9118 13.3326 18.6571 10.1451C19.4024 6.95771 21.6385 1.82242 29.2234 1.06984C36.8083 0.317256 55.661 5.89524 55.661 5.89524C55.661 5.89524 90.122 1.46826 99.9429 5.89524C109.764 10.3222 112.382 16.2101 113.754 19.8845C115.125 23.5589 115.683 36.9726 113.754 42.7719C111.825 48.5712 107.44 53.8836 99.9429 55.8757C92.4457 57.8679 50.619 55.8757 50.619 55.8757L48.1638 63.8443L56.0556 78.3648Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8745 13.5533L30.408 10.056C29.0265 10.0448 28.6254 10.3024 28.172 11.2513L26.9005 14.3502C26.6716 15.7621 26.8845 16.3664 28.172 16.9621L30.408 17.4933L42.6403 19.7068L41.8949 23.8239L49.9621 25.4619C50.7661 22.8706 50.8588 21.2818 51.409 18.6001V15.1913L49.8745 13.5533Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.959 25.4622L41.8918 23.8242L31.0625 60.9665L39.1297 62.2061L49.959 25.4622Z",
    fill: "#003E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1307 62.2513L31.0635 61.0117L24.75 81.1544L32.0719 84.8731L33.7379 77.4358H35.4478L45.3564 97.5785H72.2763V86.0241H50.793L39.1307 62.2513Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7499,
    cy: 91.4688,
    rx: 10.9609,
    ry: 11.0674,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.7812,
    cy: 91.4688,
    rx: 10.9609,
    ry: 11.0674,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2039 15.9141C64.5585 15.9141 62.9805 16.5921 61.8171 17.799C60.6536 19.0058 60 20.6427 60 22.3495V35.2204C60 36.9272 60.6536 38.5641 61.8171 39.7709C62.9805 40.9778 64.5585 41.6558 66.2039 41.6558H97.2231C98.8685 41.6558 100.446 40.9778 101.61 39.7709C102.773 38.5641 103.427 36.9272 103.427 35.2204V22.3495C103.427 20.6427 102.773 19.0058 101.61 17.799C100.446 16.5921 98.8685 15.9141 97.2231 15.9141H66.2039ZM97.2231 19.1318C98.0458 19.1318 98.8348 19.4708 99.4165 20.0742C99.9982 20.6777 100.325 21.4961 100.325 22.3495V35.2204C100.325 36.0738 99.9982 36.8922 99.4165 37.4957C98.8348 38.0991 98.0458 38.4381 97.2231 38.4381H66.2039C65.3812 38.4381 64.5922 38.0991 64.0105 37.4957C63.4287 36.8922 63.1019 36.0738 63.1019 35.2204V22.3495C63.1019 21.4961 63.4287 20.6777 64.0105 20.0742C64.5922 19.4708 65.3812 19.1318 66.2039 19.1318H97.2231ZM109.631 28.785C109.631 30.065 109.141 31.2927 108.268 32.1979C107.395 33.103 106.212 33.6115 104.978 33.6115V23.9584C106.212 23.9584 107.395 24.4669 108.268 25.372C109.141 26.2772 109.631 27.5049 109.631 28.785Z",
    fill: "#DE0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_49292",
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_49292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_49292",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat10);
export default __webpack_public_path__ + "static/media/bat_10.7e58fb9cfb5b3c2abf66a5714057921b.svg";
export { ForwardRef as ReactComponent };